import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import ContractGroupV2PanelPage from "legacy/contract-groups-v2/ContractGroupV2PanelPage"
import { afterSetState, isPresent } from "legacy/helpers.es6"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

// Note: Amplitude is loaded globally
// Note: $context is loaded globally

class ContractGroupV2Documents extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      registrationRequirement:
        this.props.form.registrationRequirement || "none",
      insuranceRequirement: this.props.form.insuranceRequirement || "none",
      notes: this.props.form.notes || "",
      attachments: this.props.form.attachments || [],
      selectedCustomFields: this.props.form.selectedCustomFields || [],
    }
    this.next = this.next.bind(this)
    this.selectAttachments = this.selectAttachments.bind(this)
    this.renderAttachment = this.renderAttachment.bind(this)
    this.handleRequiredQuestions = this.handleRequiredQuestions.bind(this)
    this.handleCustomFieldCheckBox = this.handleCustomFieldCheckBox.bind(this)
    this.customFieldDefinitions = $context.customFieldDefinitions || []
  }

  fetchData() {
    return this.state
  }

  componentWillUnmount() {
    Amplitude.trackEvent("contracts_v2:documents_complete")
    this.props.update(this.state)
  }

  next() {
    this.props.route.goNext()
  }

  registrationText() {
    if (this.state.registrationRequirement === "info") {
      return "Registration information (registration number and expiration date) will be required to sign this contract."
    } else if (this.state.registrationRequirement === "info_and_upload") {
      return "Registration information (registration number and expiration date) and proof of registration document upload will be required to sign this contract."
    } else {
      return "No registration information required to sign this contract."
    }
  }

  insuranceText() {
    if (this.state.insuranceRequirement === "info") {
      return "Insurance information (company name, policy number, and expiration date) will be required to sign this contract."
    } else if (this.state.insuranceRequirement === "info_and_upload") {
      return "Insurance information (company name, policy number, and expiration date) and proof of insurance document upload will be required to sign this contract."
    } else {
      return "No insurance information required to sign this contract."
    }
  }

  renderDocumentSelector() {
    if ((this.props.marinaAttachments || []).length) {
      return (
        <div className="form-group">
          <label>Documents</label>
          <a
            className="float-right"
            href={this.props.editDocumentUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Edit Documents
          </a>
          <div
            className="overflow-auto rounded border px-4"
            style={{ maxHeight: "250px" }}
          >
            {_.map(this.props.marinaAttachments, this.renderAttachment)}
          </div>
        </div>
      )
    } else {
      return (
        <a
          className="block"
          href={this.props.editDocumentUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Upload Documents
        </a>
      )
    }
  }

  renderAttachment(attachment) {
    return (
      <div className="checkbox" key={attachment.id}>
        <label>
          <input
            type="checkbox"
            checked={
              _.filter(this.state.attachments, {
                attachment_file_id: attachment.attachment_file_id,
              }).length
            }
            value={attachment.attachment_file_id}
            onChange={this.selectAttachments}
          />
          {attachment.name}
        </label>
      </div>
    )
  }

  badgeForCustomFieldSelect(value) {
    return value ? "badge-blue" : "badge-teal"
  }

  renderCustomFieldQuestionSelector() {
    if (this.customFieldDefinitions.length > 0) {
      return (
        <div className="form-group">
          <label
            className="mb-0 pb-2 pr-2 font-semibold"
            data-container="body"
            data-toggle="popover"
            data-placement="right"
            data-content="Check the box for each question you would like to be included on the contract signing page. Also, select if you would like the question to be required or optional."
          >
            Custom Fields
            <i className="icon icon-info text-muted ml-3" />
          </label>
          <div
            className="mb-3 space-y-1 overflow-auto rounded border px-4 py-3"
            style={{ maxHeight: "250px" }}
          >
            {_.map(this.customFieldDefinitions, (field) =>
              this.renderCustomField(
                field,
                _.find(this.state.selectedCustomFields, {
                  customFieldDefinitionId: field.id,
                })
              )
            )}
          </div>
        </div>
      )
    }
  }

  renderCustomField(field, selectedCustomField) {
    return (
      <div
        key={field.key}
        className="grid min-h-8 grid-cols-4 items-center gap-x-2"
      >
        <div className="col-span-3 col-start-1">
          <FormGroup
            inputType="checkbox"
            name={field.key}
            value={isPresent(selectedCustomField)}
            onChange={() =>
              this.handleCustomFieldCheckBox(
                field.id,
                !isPresent(selectedCustomField)
              )
            }
            label={field.title}
            className="my-1"
          />
        </div>
        {isPresent(selectedCustomField) && (
          <div className="col-start-4 flex justify-end">
            <div className="static">
              <FormGroup
                inputType="select"
                customStyle={{ WebKitAppearance: "none" }}
                name={field.id}
                value={selectedCustomField.required ? "required" : "optional"}
                onChange={() =>
                  this.handleRequiredQuestions(selectedCustomField)
                }
                className={`badge mb-0 p-0.5 outline-none ${this.badgeForCustomFieldSelect(
                  selectedCustomField.required
                )}`}
              >
                <option value="required">Required</option>
                <option value="optional">Optional</option>
              </FormGroup>
            </div>
          </div>
        )}
      </div>
    )
  }

  handleCustomFieldCheckBox(id, value) {
    const customFieldDefinition = _.find(this.customFieldDefinitions, { id })
    if (value) {
      const selectedCustomField = {
        customFieldDefinitionId: customFieldDefinition.id,
        required: true,
      }
      this.setState({
        selectedCustomFields: [
          ...this.state.selectedCustomFields,
          selectedCustomField,
        ],
      })
    } else {
      const selectedCustomFields = _.reject(this.state.selectedCustomFields, {
        customFieldDefinitionId: id,
      })
      this.setState({ selectedCustomFields })
    }
  }

  handleRequiredQuestions(selectedCustomField) {
    const selectedCustomFields = [...this.state.selectedCustomFields]
    const selectedCustomFieldIndex = _.indexOf(
      selectedCustomFields,
      selectedCustomField
    )
    selectedCustomFields[selectedCustomFieldIndex] = {
      ...selectedCustomField,
      required: !selectedCustomField.required,
    }
    this.setState({ selectedCustomFields })
  }

  selectAttachments(event) {
    let attachments = []
    const currentAttachments = this.state.attachments
    if (event.target.checked) {
      // current attachments plus new
      attachments = [
        ...currentAttachments,
        ..._.filter(this.props.marinaAttachments, {
          attachment_file_id: parseInt(event.target.value),
        }),
      ]
    } else {
      // current attachments minus new
      attachments = _.reject(currentAttachments, {
        attachment_file_id: parseInt(event.target.value),
      })
    }
    this.setState({ attachments })
  }

  save() {
    this.props.startSave()
    afterSetState(this.props.doUpdate)
  }

  render() {
    return (
      <ContractGroupV2PanelPage
        hasNext={true}
        hasPrevious={this.props.route.hasPrevious}
        goNext={() => this.save()}
        goPrevious={this.props.route.goPrevious}
        saving={this.props.saving}
        nextButtonType="primary"
        nextButtonTitle={this.props.action}
      >
        <FormGroup
          inputType="select"
          label="Require Registration"
          name="registrationRequirement"
          value={this.state.registrationRequirement}
          onChange={this.handleInputChange}
        >
          {_.map(this.props.documentRequirements, (option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </FormGroup>
        <p className="text-muted -mt-3 mb-4">{this.registrationText()}</p>
        <FormGroup
          inputType="select"
          label="Require Insurance"
          name="insuranceRequirement"
          value={this.state.insuranceRequirement}
          onChange={this.handleInputChange}
        >
          {_.map(this.props.documentRequirements, (option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </FormGroup>
        <p className="text-muted -mt-3 mb-4">{this.insuranceText()}</p>
        <hr />
        {this.renderDocumentSelector()}
        {this.renderCustomFieldQuestionSelector()}
        <div className="form-group">
          <label
            className="mb-0 pb-2 pr-2"
            data-container="body"
            data-toggle="popover"
            data-placement="right"
            data-content="These notes will be included on the first page of the contract. Use this field to include additional information that the boater must know before signing."
            htmlFor="notes"
          >
            Contract Notes
            <i className="icon icon-info text-muted ml-3" />
          </label>
          <textarea
            id="notes"
            className="form-control"
            name="notes"
            rows="4"
            value={this.state.notes}
            onChange={this.handleInputChange}
          />
        </div>
      </ContractGroupV2PanelPage>
    )
  }
}

ContractGroupV2Documents.propTypes = {
  form: PropTypes.shape({
    registrationRequirement: PropTypes.string,
    insuranceRequirement: PropTypes.string,
    notes: PropTypes.string,
    attachments: PropTypes.array,
    selectedCustomFields: PropTypes.arrayOf(
      PropTypes.shape({
        customFieldDefinitionId: PropTypes.number.isRequired,
        required: PropTypes.bool.isRequired,
      })
    ),
  }).isRequired,
  update: PropTypes.func.isRequired,
  route: PropTypes.shape({
    hasNext: PropTypes.bool,
    hasPrevious: PropTypes.bool,
    goNext: PropTypes.func,
    goPrevious: PropTypes.func,
  }).isRequired,
  marinaAttachments: PropTypes.array,
  editDocumentUrl: PropTypes.string,
  documentRequirements: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  saving: PropTypes.bool,
  startSave: PropTypes.func,
  doUpdate: PropTypes.func,
  action: PropTypes.node,
}

export default ContractGroupV2Documents
